// extracted by mini-css-extract-plugin
module.exports = {"text":"_51292f0"};